import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import colors from "./colors.json";

export function formatBytes(x) {
    const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let l = 0,
      n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
  }


export const setBldingIds = (bldList,buildingsSelector): Array<number> => {
    let id: Array<number> = [];
    bldList.forEach((bl) => {
      buildingsSelector.forEach((bldSelector) => {
        if (bldSelector.siteName === bl) id.push(bldSelector.siteID);
      });
    });
    return id;
  };


  export const DragAndDropContainer = styled.div`
  cursor: pointer;
  position: relative;
  border: 2px dashed #999999;
  text-align: center;
  height: 150px;
  width: ${(props) => props.width && props.width};
  margin: 0 0 16px 0;
  background-color: #fff;
  label {
    cursor: pointer;
  }
`;


export const BrowseFileText = styled.h6`
  font-weight: bold;
`;

export const DropFileText = styled.h1`
  font-size: 16px;
  font-weight: bold;
`;

export const FileListUL = styled.ul`
  width: 460px;
  text-align: left;
  list-style: none;
  margin: 0px;
  padding: 0;
  height: 150px;
  overflow: auto; /* Hide scrollbars */

`;

export const FileTemplateListUL = styled.ul`
  width: 460px;
  text-align: left;
  list-style: none;
  margin: 0px;
  padding: 0;
  height: auto;
  overflow: auto; /* Hide scrollbars */

`;

export const TableContainer = styled.div`
  width: 100%;
  position: relative;
  letter-spacing: 0.24px;
  font-family: Arial;
  margin: 10px 0px;
  box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 10%);
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  font-size: 14px;
  font-family: Arial;
  height: 60px;
  color: ${colors.GREY_4};
  background: ${(props) =>
    props.iterator % 2 === 0
      ? props.evenColor
        ? props.evenColor
        : `${colors.TBA_ALMOST_WHITE}`
      : props.oddColor
      ? props.oddColor
      : `${colors.WHITE}`};
  border-top: 1px solid ${colors.TBA_ALMOST3_WHITE};
  border-bottom: 1px solid ${colors.TBA_ALMOST3_WHITE};
  td.hoverOnly {
    div, span, button {
      display: none;
    }
  }
  &:hover {
    background: ${colors.LIGHT_BLUE_1};
    td.hoverOnly {
      div, span, button {
        display: inherit;
      }
    }
  }
  &:last-child {
    td:first-child {
      border-bottom-left-radius: 8px;
    }
    td:last-child {
      border-bottom-right-radius: 8px;
    }
  }
`;
export const TableHead = styled.thead`
  background: ${(props) =>
    props.isError ? colors.RED_5 : colors.WHITE};
  ${(props) => props.isError && `border-bottom: 2px solid ${colors.RED};`}
  color: ${(props) => (props.isError && colors.RED)};
  height: 60px;
  font-size: 16px;
  font-family: NeueHaasUnica-Regular;

  border-top-left-radius: 8px;
`;

export const TableHeadCell = styled.th`
  color: #504949;
  &:first-child {
    border-top-left-radius: 8px;
    padding-left: 14px;
  }
  &:last-child {
    border-top-right-radius: 8px;
    text-align: right;
    padding-right: 14px;
  }
  vertical-align: middle;
  text-align: left;
`;

export const TableStyle = styled.table`
  border-collapse: separate;
  border-spacing: 0px;
  border: 1px solid ${colors.TBA_ALMOST3_WHITE};
  border-radius: "8px 8px 8px 8px";
  width: 100%;
  &:hover tr {
    th.hoverOnlyHeader {
        display: table-cell;
    }
  }
`;

export const TableHeadRow = styled.tr`
border-top-left-radius: 8px;
`;



export const TableCell = styled.td`
	color: ${colors.GREY_7};
  ${(props) => props.maxWidth ? `max-width: ${props.maxWidth};` : ""}
  vertical-align: middle;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-top: 1px solid ${colors.TBA_ALMOST3_WHITE};
  padding-right: 18px;
  &:first-child {
    padding-left: 14px;
  }
  &:last-child {
    text-align: right;
    padding-right: 14px;
  }
`;

export const ArrowContainer = styled.div`
  padding: 0 0 0 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowSpan = styled.span`
    padding-left: 10px;
    position: absolute;
    display: inline-grid;
`

export const HeaderDiv = styled.div`
    background: ${colors.WHITE};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    align-items: center;
    display: flex;
    height: 60px;
    color: rgb(54,54,54);
    width: 100%;
    padding: 0px 14px 0px 14px;
    border-radius: 8px 8px 0px 0px;
    border-top: 1px solid ${colors.TBA_ALMOST3_WHITE};
    border-left: 1px solid ${colors.TBA_ALMOST3_WHITE};
    border-right: 1px solid ${colors.TBA_ALMOST3_WHITE};
`

export const useStyles = makeStyles((theme) => ({
  indeterminateColor: {
    color: "#f50057"
  },
  selectAllText: {
    fontWeight: 500,
    fontSize:'16px',
    paddingTop:'10px'
  },
  selectedCountText: {
    fontWeight: 'normal',
    fontSize:'14px',
    paddingTop:'10px',
    color:'rgb(112, 112, 112)'
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
  }
}));